import React from "react";
import { Head } from '@inertiajs/react';

const SEO = ({title = '', description = ''}) => (
    <>
        <Head>
            <title>{title}</title>
            <meta name="description" content={description} />
        </Head>
    </>
);

export default SEO;
